module.exports = __webpack_public_path__ + "img/camera_no.6093422f.png";